import {
    GET_PRODUCTS,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    GET_PRODUCT_DETAIL,
    GET_PRODUCT_DETAIL_SUCCESS,
    GET_PRODUCT_DETAIL_FAIL,
    ADD_NEW_PRODUCT,
    ADD_NEW_PRODUCT_SUCCESS,
    ADD_NEW_PRODUCT_FAIL,
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
} from "./actionTypes"

export const getProducts = (params) => ({
    type: GET_PRODUCTS,
    payload: params,
})

export const getProductsSuccess = (products) => ({
    type: GET_PRODUCTS_SUCCESS,
    payload: products,
})

export const getProductsFail = (error) => ({
    type: GET_PRODUCTS_FAIL,
    payload: error,
})

export const getProductDetail = (id) => ({
    type: GET_PRODUCT_DETAIL,
    payload: id,
})

export const getProductDetailSuccess = (product) => ({
    type: GET_PRODUCT_DETAIL_SUCCESS,
    payload: product,
})

export const getProductDetailFail = (error) => ({
    type: GET_PRODUCT_DETAIL_FAIL,
    payload: error,
})

export const addNewProduct = (product) => ({
    type: ADD_NEW_PRODUCT,
    payload: product,
})

export const addNewProductSuccess = (product) => ({
    type: ADD_NEW_PRODUCT_SUCCESS,
    payload: product,
})

export const addNewProductFail = (error) => ({
    type: ADD_NEW_PRODUCT_FAIL,
    payload: error,
})

export const updateProduct = (product) => ({
    type: UPDATE_PRODUCT,
    payload: product,
})

export const updateProductSuccess = (product) => ({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: product,
})

export const updateProductFail = (error) => ({
    type: UPDATE_PRODUCT_FAIL,
    payload: error,
})

export const deleteProduct = (id) => ({
    type: DELETE_PRODUCT,
    payload: id,
})

export const deleteProductSuccess = (id) => ({
    type: DELETE_PRODUCT_SUCCESS,
    payload: id,
})

export const deleteProductFail = (error) => ({
    type: DELETE_PRODUCT_FAIL,
    payload: error,
})
